import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/Reporte/deuda';
import CuentasPorPoC from './cuentaspor';

const mstp = state => {
    return {...state.Reportes, es_cliente:false, permisos: state.login.me.permisos}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(CuentasPorPoC)
